<div class="bmc-authentication">
  <div class="bmc-authentication__container" *ngIf="!!metadata">
    <div class="bmc-authentication__auth-type-container">
      <bzg-message *ngIf="!isEditable" class="bmc-authentication__message--info" [showCloseBtn]="true" [status]="'info'">
        <span class="bz-space--inline-s "> {{'AUTHENTICATION.WINDOW_MAINTENANCE_REQUIRED' | translate}} </span>
        <bzg-button-secondary class="bz-space--inline-m" (click)="navigateWindowMaintenance()">
          {{ "AUTHENTICATION.GO_MAINTENANCE_WINDOW" | translate }}
        </bzg-button-secondary>
      </bzg-message>
      <bzg-message *ngIf="isEditable && isValidAuthentication" class="bmc-authentication__message--info" [showCloseBtn]="true" [status]="'info'">
        <span class="bz-space--inline-s "> {{ "AUTHENTICATION.TITLE" | translate }} </span>
        <bzg-button-secondary class="bz-space--inline-m" (click)="navigateWindowMaintenance()">
          {{'AUTHENTICATION.END_MAINTENANCE_WINDOW' | translate}}
        </bzg-button-secondary>
      </bzg-message>
      <bzg-message *ngIf="!isValidAuthentication && isEditable && showErrorHeader" [showCloseBtn]="false" [status]="'error'">
        {{getMessage()}}
      </bzg-message>
      <div class="bmc-authentication__auth-type bz-space--stack-l">
        <div class="bmc-authentication__auth-type__left">
          <label
            class="bz-form-label bmc-authentication__selector-title bz-space--stack-s">{{ "AUTHENTICATION.SUBTITLE_TYPE" | translate }}</label>
          <bzg-select [placeholder]="initialAuthenticationType ? initialAuthenticationType : 'AUTHENTICATION.SELECT_A_TYPE' | translate"
            [value]="selectedMethod ? selectedMethod.type : {}" (valueChange)="onTypeOrSubtypeChange($event, null, true)"
            [disabled]="!isEditable">
            <bzg-option *ngFor="let method of metadata | keyvalue" [value]="method.key">
              {{ 'AUTHENTICATION.TYPE_' + method.key | translate }}</bzg-option>
          </bzg-select>
          <div *ngIf="selectedMethod && metadata[selectedMethod.type] && metadata[selectedMethod.type].config">
            <div *ngIf="metadata[selectedMethod.type].config">
              <div class="bmc-authentication__subtype-selector" *ngIf="metadata[selectedMethod.type].config.subtypes">
                <label
                  class="bz-form-label bmc-authentication__selector-title bz-space--stack-s">{{ "AUTHENTICATION.SUBTYPE" | translate }}</label>
                <bzg-select [value]="selectedMethod.subtype" (valueChange)="onTypeOrSubtypeChange(selectedMethod.type, $event, false)"
                  [disabled]="!isEditable">
                  <bzg-option *ngFor="let method of metadata[selectedMethod.type].config.subtypes.options" [value]="method">
                    {{ 'AUTHENTICATION.SUBTYPE_' + method | translate }}</bzg-option>
                </bzg-select>
              </div>

              <div class="bmc-authentication__subtype-selector" *ngIf="metadata[selectedMethod.type].config.flows">
                <label
                  class="bz-form-label bmc-authentication__selector-title bz-space--stack-s">{{ "AUTHENTICATION.ACTIVE_FLOW" | translate }}</label>
                <bzg-select [value]="selectedMethod.oauthOptions.activeFlow"
                  (valueChange)="onFlowChange(selectedMethod, $event)" [disabled]="!isEditable">
                  <bzg-option
                    *ngFor="let flow of metadata[selectedMethod.type].config.flows.options[selectedMethod.subtype].options"
                    [value]="flow">{{ 'AUTHENTICATION.OPTIONS_' + flow | translate }}</bzg-option>
                </bzg-select>
              </div>


              <div *ngIf="metadata[selectedMethod.type].config.bizagiDomain" class="bmc-authentication__selector-title">
                <bzg-input class="bmc-authentication__auth-type__mixed__input"
                  [(ngModel)]="selectedMethod.options.bizagiDomain" name="domain-input" [disabled]="!isEditable">
                  {{ 'AUTHENTICATION.OPTIONS_bizagiDomain' | translate }}
                </bzg-input>
              </div>

              <div class="bmc-authentication__selector-title"
                *ngIf="metadata[selectedMethod.type].config.otherAuthenticationType">
                <label class="bz-form-label"
                  for="bmc-other-auth">{{ 'AUTHENTICATION.OPTIONS_otherAuthenticationType' | translate }}</label>
                <bzg-select id="bmc-other-auth" [(value)]="selectedMethod.options.otherAuthenticationType"
                  (valueChange)="changeOtherAuthentication($event)" [disabled]="!isEditable">
                  <bzg-option *ngFor="let otherAuth of metadata[selectedMethod.type].config.otherAuthenticationType.options"
                    [value]="otherAuth">{{otherAuth}}</bzg-option>
                </bzg-select>
              </div>
            </div>
          </div>
        </div>

        <div class="bmc-authentication__auth-type__right">
          <bzg-button-primary class="bmc-authentication__auth-type__right__button"
              [disabled]="!isEditable || !selectedMethod || !isMultipleAuthDetailValid()"
              (click)="SaveAll()">
                {{ "GLOBAL.SAVE" | translate }}
              </bzg-button-primary>
        </div>

      </div>

      <div class="bz-divider bz-divider--horizontal bz-space--stack-l"></div>

      <div *ngIf="selectedMethod && authMethodsVpnRequired.indexOf(selectedMethod.type) >= 0 || (selectedMethod?.options?.otherAuthenticationType
          && authMethodsOtherVpnRequired.indexOf(selectedMethod.options.otherAuthenticationType) >= 0)">
        {{ "AUTHENTICATION.VPN_REQUIRED" | translate }}
      </div>
    </div>

    <div class="bmc-authentication-properties"
      *ngIf="selectedMethod && selectedMetadata && selectedMethod.type !== 'Multiple'">
      <biz-security-auth-list [selectedMethod]="selectedMethod" [selectedMixedMethod]="selectedMixedMethod"
        [methodType]="methodType" [selectedFlow]="selectedFlow"
        [selectedMetadata]="selectedMetadata" [selectedOption]="selectedOption"
        [currentValue]="currentValue" (onSelectOption)="selectOption($event)"
        (onSelectOAuthOption)="selectOAuthOption($event)" (onSetMixedOption)="selectMixedOption($event)">
      </biz-security-auth-list>
      <biz-security-auth-detail #bzSecurityAuthDetail
        [isEditable]="isEditable"
        [currentFileName]="currentFileName"
        [currentAllowedExtensions]="currentAllowedExtensions"
        [selectedMetadata]="selectedMetadata"
        [selectedOption]="selectedOption"
        [currentValue]="currentValue"
        (onUpdateData)="updateData($event.option, $event.currentValue, $event.isOauth, $event.fileName, $event.currentFileName)">
      </biz-security-auth-detail>
    </div>
    <div class="bmc-authentication-properties"
      *ngIf="selectedMethod && selectedMetadata && selectedMethod.type === 'Multiple'">
      <biz-multiple-auth-list (onChangeViewMode)="setMultipleViewMode($event.mode, $event.authenticator)"
        [metadata]="(metadata$ | async)"
        [authenticatorList] = "(authenticatorList$ | async)"
        [viewMode]="(multipleViewMode$ | async)"
        [isEditable]="(isEditable$ | async)"
        [multipleOptionsMetadata]="(multipleOptions$ | async)"
        [currentAuthenticator]="(currentAuthenticator$ | async)"
        (onSelectOption)="selectMultipleOption($event)"
        (onSelectOAuthOption)="selectMultipleOAuthOption($event)"
        (onDeleteAuthenticators)="deleteAuthenticators($event)">
      </biz-multiple-auth-list>
      <biz-multiple-auth-detail #bzMultipleAuthDetail *ngIf="!showOptionDetail && ((multipleViewMode$ | async) === 2 || (multipleViewMode$ | async) === 0 || (multipleViewMode$ | async) === 1)"
        [optionsDefaultValues]="(multipleOptionsDefaultValues$ | async)"
        [metadata]="(multipleOptions$ | async)"
        [isEditable]="(isEditable$ | async)"
        [selectedAuthenticator]="(currentAuthenticator$ | async)"
        [viewMode]="(multipleViewMode$ | async)"
        [isDisabled]="isDisabled((currentAuthenticator$ | async))"
        (onSetNewAuthenticator)="setNewAuthenticator($event)"
        (onCancel)="onCancelMultipleDetail($event)"
        (onUpdateAuthenticator)="updateAuthenticator($event)"
        (onChangeDomainList)="updateDomainList($event)">
      </biz-multiple-auth-detail>
      <biz-security-auth-detail #bzSecurityAuthDetail *ngIf="showOptionDetail"
        [isEditable]="(isEditable$ | async)"
        [currentFileName]="currentFileName"
        [currentAllowedExtensions]="currentAllowedExtensions"
        [selectedMetadata]="(currentAuthenticatorOptionsMetadata$ | async)"
        [isDisabled]="isDisabled((currentAuthenticator$ | async))"
        [selectedOption]="selectedOption"
        [currentValue]="currentValue"
        (onUpdateData)="updateData($event.option, $event.currentValue, $event.isOauth, $event.fileName, $event.currentFileName)">
      </biz-security-auth-detail>
    </div>
    <bzg-message *ngIf="!isValidAuthentication && isEditable && !showErrorHeader" [showCloseBtn]="false" [status]="'error'">
      {{getMessage()}}
    </bzg-message>
  </div>

  <div class="bz-env-loading" *ngIf="loadingAuthentication">
    <bounce></bounce>
  </div>

</div>
